import styled from "styled-components";
import { colorsPalettes, mixins, setFontVariant, truncateText } from "@similarweb/styles";

export const StyledInput = styled.input`
    cursor: pointer;
`;

export const StyledFieldContainer = styled.div`
    position: relative;
    box-sizing: border-box;
    min-height: 40px;
    border: 1px solid ${colorsPalettes.midnight["50"]};
    border-radius: 3px;
    padding: 4px 16px;

    ${StyledInput} {
        ${mixins.setFont({ $size: 14, $color: colorsPalettes.carbon["400"], $weight: 400 })};
        border: none;
        box-shadow: none;
        display: block;
        height: 28px;
        line-height: 16px;
        margin: 0;
        padding: 0;
        width: 100%;

        &::placeholder {
            color: ${colorsPalettes.carbon["200"]};
        }
    }
`;

export const StyledChipContainer = styled.div`
    max-width: 100%;
    display: inline-flex;
    gap: 8px;
    flex-wrap: wrap;

    & div {
        max-width: 100%;
        overflow: hidden;
    }
`;

export const StyledAddContainer = styled.div`
    position: absolute;
    left: 0;
    display: block;
    z-index: 1050;
    border-radius: 3px;
    background-color: #fff;
    box-shadow: 0 3px 5px #2a3e521f;
    border: solid 1px ${colorsPalettes.carbon[100]};
    width: 100%;
    transform: translateY(15px);
    padding: 8px 0;
`;

export const StyledAddButton = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    position: relative;
    width: 100%;
    height: 42px;
    padding: 12px 20px 10px 22px;
    background-color: #fff;
    text-align: left;
    ${setFontVariant("input2", colorsPalettes.blue["400"])};
    box-sizing: border-box;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    &:hover {
        background-color: ${colorsPalettes.bluegrey["100"]};
    }
`;

export const StyledAddButtonText = styled.span`
    ${truncateText()};
`;
